<template>
    <div class="feedback">
      <pageTitle v-bind="{ ...pT }" />
      <business-group
        ref="businessGroup"
        :tableConfig="{ ...tableConfig }"
        :formConfig="{ ...formConfig }"
      >
      <template slot="formSlot" slot-scope="formSlot">
        <a-form-item>
          <a-input
            placeholder="请输入邮箱"
            v-decorator="['emailName']"
            style="width: 200px; margin-right: 10px; vertical-align: middle"
          />
        </a-form-item>
      </template>
      <template slot="action" slot-scope="record">
        <a-button type="link" @click="detail(record.id)">查看</a-button>
        <!-- <a-button type="link" @click="edit(record)">处理</a-button> -->
      </template>
      </business-group>
      <a-modal title="用户返回详情内容" destroyOnClose :visible="visible" :maskClosable="false" @ok="() => visible = false" @cancel="() => visible = false">
      <a-form-model :modal="detailsInfo" class="info" layout="vertical" :label-col="labelCol"
                    :wrapper-col="wrapperCol">
        <a-form-model-item label="用户邮箱：">
          <span  v-text="detailsInfo.emailName" />
        </a-form-model-item>
        <a-form-model-item label="用户反馈内容：">
          <span  v-text="detailsInfo.feedbackContent" />
        </a-form-model-item>
        <a-form-model-item label="反馈时间：">
          <span  v-text="detailsInfo.createDateTime" />
        </a-form-model-item>
        <a-form-model-item label="阅读状态：">
          <span  v-text="readingStatusMap[detailsInfo.readingStatus]" />
        </a-form-model-item>
        <a-form-model-item label="处理状态：">
          <span  v-text="processingStatusMap[detailsInfo.processingStatus]" />
        </a-form-model-item>

        <a-form-model-item label="反馈图片：">
          <template v-if="!detailsInfo.imageData">
              用户没有上传图片
          </template>

          <template v-if="detailsInfo.imageData">
              <img
              :width="200"
                :src="detailsInfo.imageData"
              >
          </template>
          <template v-if="detailsInfo.imageDataSecond">
            <a-divider />
              <img
              :width="200"
                :src="detailsInfo.imageData"
              >
          </template>
          <template v-if="detailsInfo.imageDataThird">
            <a-divider />
              <img 
              :width="200"
                :src="detailsInfo.imageDataThird"
              >
          </template>
          <template v-if="detailsInfo.imageDataForth">
            <a-divider />
              <img 
              :width="200"
                :src="detailsInfo.imageDataForth"
              >
          </template>
        </a-form-model-item>
      </a-form-model>
      </a-modal>
    </div>
  </template>
  
  <script>
  import pageTitle from "@/components/business/pageTitle";
  import businessGroup from "@/components/business/businessGroup";
  import mImage from "@/components/business/mImage/mImage";
  import { tips } from "@/utils/util";

  export default {
    components: {
      pageTitle,
      businessGroup,
      mImage
    },
    name: "feedback",
    created() {
      this.pT.pageTitle = this.$route?.meta?.title || "";
    },
    data() {
      return {
        readingStatusMap:{0:"未阅读",1:"已阅读"},
        processingStatusMap:{0:"未处理",1:"已处理"},
        labelCol: { span: 8 },
        wrapperCol: { span: 15 },
        pT: { pageTitle: "" },
        visible:false,
        tableConfig: {
          url: "/manage/Feedback/list",
          columns: [
            {
              title: "序号",
              dataIndex: "id",
              key: "id",
              align: "center",
            },
            {
              title: "邮箱",
              dataIndex: "emailName",
              key: "emailName",
              align: "center",
              width: 200
            },
            {
              title: "阅读状态",
              dataIndex: "readingStatus",
              key: "readingStatus",
              align: "center",
              customRender: (text)=>{
                  return this.readingStatusMap[text];
              }   
            },
            {
              title: "处理状态",
              key: "processingStatus",
              dataIndex: "processingStatus",
              align: "center",       
              customRender: (text)=>{
                  return this.processingStatusMap[text];
              }      
            },
            {
              title: "反馈内容",
              key: "feedbackContent",
              dataIndex: "feedbackContent",
              align: "center"
            },
            {
              title: "反馈时间",
              key: "createDateTime",
              dataIndex: "createDateTime",
              align: "center"
            },
            {
              title: "操作",
              scopedSlots: { customRender: "action" },
              align: "center",
              width: 150,
            }
          ],
          rowKey: "feedbackId",
          urlType:"api"
        },
        formConfig: {
          formShow: true,
          hideHeader: false,
        },
        detailsInfo:{},
      };
    },
    methods:{
      detail: async function(id){
          if (this.loading) return false;
        
          this.loading = true;
          const res = await this.$get(`/manage/Feedback/detail?id=` + id,null,"api");
          this.loading = false;
          const instDetail = res?.resultData || false;
          if(!instDetail){
            tips(this, false, res?.errorMessage);
            return false;
          }

          this.detailsInfo = {
            ...instDetail
          }

          this.visible = true;
        }
    }
  };
  </script>
  
  <style lang="less">
  .feedback-nickname {
    display: flex;
    align-items: center;
    justify-content: center;
    .Image {
      width: 40px;
      border-radius: 50%;
      border:1px solid rgb(230, 228, 228);
    }
  }
  </style>
  
  